import { AllCommunityModule, Module } from 'ag-grid-community';
import {
  CellSelectionModule,
  ClipboardModule,
  ColumnMenuModule,
  ColumnsToolPanelModule,
  ContextMenuModule,
  ExcelExportModule,
  GroupFilterModule,
  MasterDetailModule,
  RichSelectModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  SetFilterModule,
  SideBarModule,
  StatusBarModule,
  TreeDataModule,
} from 'ag-grid-enterprise';

/**
 * Every AG Grid module the app uses, registered at boot and in grid tests. A grid that needs a module
 * missing here logs AG Grid error #200 naming it and that feature stops working, so a grid that starts
 * using another enterprise feature adds its module here.
 */
export const gridModules: Module[] = [
  AllCommunityModule,
  CellSelectionModule, // range selection: cap table, financials, bulk transactions, KPI settings
  ClipboardModule, // copy and paste, on by default on every grid
  ColumnMenuModule, // header menus, custom main menu items and the financials column chooser
  ColumnsToolPanelModule, // the columns panel in the overview side bar
  ContextMenuModule, // the right-click menu, on by default on every grid
  ExcelExportModule, // Excel exports, from export buttons and the context menu
  GroupFilterModule, // agGroupColumnFilter on grouped grids
  MasterDetailModule, // the tearsheet generation grid
  RichSelectModule, // agRichSelectCellEditor
  RowGroupingModule, // row grouping, aggregation and grand totals
  RowGroupingPanelModule, // the drag-to-group bar, and any rowGroupPanelShow setting
  SetFilterModule, // set filters, and the default filter on filter: true
  SideBarModule, // the overview side bar
  StatusBarModule, // row counts on the KPI request grids
  TreeDataModule, // tree data on Portfolio, funds overview, financials and collected KPI data
];
